import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _TipInfo;
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
/** @jsx jsx */
import { Component } from 'react';
import { Link } from '@instructure/ui-link';
import { jsx } from '@instructure/emotion';
import PropTypes from 'prop-types';
import generateStyle from './styles';
import generateComponentTheme from './theme';
import t from '@instructure/quiz-i18n/format-message';
import { withStyleOverrides } from '@instructure/quiz-common';
var TipInfo = (_dec = withStyleOverrides(generateStyle, generateComponentTheme), _dec(_class = (_TipInfo = /*#__PURE__*/function (_Component) {
  function TipInfo() {
    _classCallCheck(this, TipInfo);
    return _callSuper(this, TipInfo, arguments);
  }
  _inherits(TipInfo, _Component);
  return _createClass(TipInfo, [{
    key: "render",
    value: function render() {
      return jsx("div", null, jsx("div", {
        css: this.props.styles.tipTitle
      }, t('Contains')), jsx("div", null, t('The word can exist anywhere in the response')), jsx("div", {
        css: this.props.styles.tipTitle
      }, t('Close Enough')), t.rich('Uses <0>Levenshtein Distance</0> to determine if the response is close enough to the correct answer.', [function (_ref) {
        var children = _ref.children;
        return jsx(Link, {
          key: "0",
          href: "https://en.wikipedia.org/wiki/Levenshtein_distance",
          target: "_blank",
          rel: "noopener noreferrer"
        }, children);
      }]), jsx("div", {
        css: this.props.styles.tipTitle
      }, t('Exact Match')), jsx("div", null, t('Case and spelling must match exactly')), jsx("div", {
        css: this.props.styles.tipTitle
      }, t('Specify Correct Answers')), jsx("div", null, t('You specify each acceptable response')), jsx("div", {
        css: this.props.styles.tipTitle
      }, t('Regular Expression Match')), jsx("div", null, t('Not for beginners. Be sure your pattern is valid for Ruby 2.5 or it may fail.')), jsx("ul", null, jsx("li", null, t.rich('Use a validator such as <0>Rubular</0> to test your pattern.', [function (_ref2) {
        var children = _ref2.children;
        return jsx(Link, {
          key: "1",
          href: "https://rubular.com/",
          target: "_blank",
          rel: "noopener noreferrer"
        }, children);
      }])), jsx("li", null, t.rich('Review Ruby’s <0>Regexp</0> documentation for more context.', [function (_ref3) {
        var children = _ref3.children;
        return jsx(Link, {
          key: "2",
          href: "https://ruby-doc.org/core-2.5.0/Regexp.html",
          target: "_blank",
          rel: "noopener noreferrer"
        }, children);
      }]))));
    }
  }]);
}(Component), _defineProperty(_TipInfo, "displayName", 'TipInfo'), _defineProperty(_TipInfo, "componentId", "Quizzes".concat(_TipInfo.displayName)), _defineProperty(_TipInfo, "propTypes", {
  styles: PropTypes.object
}), _TipInfo)) || _class);
export { TipInfo as default };